import PrimarySecondary from './PrimarySecondary';
import PrimarySecondaryAvatar, { PrimarySecondaryAvatarWrapped } from './PrimarySecondaryAvatar';
import PrimarySecondaryLoading from './PrimarySecondaryLoading';

export default PrimarySecondary;
export { PrimarySecondaryLoading, PrimarySecondaryAvatar, PrimarySecondaryAvatarWrapped };
